export { default as ListView } from 'inpc/components/InpcListView';
export { default as FormView } from 'inpc/components/InpcFormView';
export { default as Row } from 'inpc/components/list/InpcListRow';



// WEBPACK FOOTER //
// src/modules/secured/modules/inpc/components/index.js